import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Popover, List, ListItem, ListItemText, Typography, Box, Chip } from '@mui/material';
import { Notifications as NotificationsIcon } from '@mui/icons-material';
import axios from 'axios';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewedIds, setViewedIds] = useState([]);

  useEffect(() => {
    const stored = localStorage.getItem('viewedNotifications');
    if (stored) setViewedIds(JSON.parse(stored));
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 30000);
    return () => clearInterval(interval);
  }, []);

  const fetchNotifications = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || '/api';
      const { data } = await axios.get(`${API_URL}/notifications/active`);
      setNotifications(data);
    } catch (error) {
      if (error.response?.status !== 401) {
        // eslint-disable-next-line no-console
        console.error('Erro ao buscar notificações:', error);
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    const ids = notifications.map(n => n._id);
    setViewedIds(ids);
    localStorage.setItem('viewedNotifications', JSON.stringify(ids));
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getTypeColor = (type) => {
    const colors = {
      maintenance: 'warning',
      instability: 'error',
      improvement: 'success',
      info: 'info',
      warning: 'warning',
      critical: 'error'
    };
    return colors[type] || 'default';
  };

  const getTypeLabel = (type) => {
    const labels = {
      maintenance: 'Manutenção',
      instability: 'Instabilidade',
      improvement: 'Melhoria',
      info: 'Informação',
      warning: 'Aviso',
      critical: 'Crítico'
    };
    return labels[type] || type;
  };

  const open = Boolean(anchorEl);
  const unreadCount = notifications.filter(n => !viewedIds.includes(n._id)).length;

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Box sx={{ width: 350, maxHeight: 400, overflow: 'auto' }}>
          {notifications.length === 0 ? (
            <Box sx={{ p: 2, textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary">
                Nenhuma notificação no momento
              </Typography>
            </Box>
          ) : (
            <List>
              {notifications.map((notification) => (
                <ListItem key={notification._id} divider>
                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                        <Typography variant="subtitle2">{notification.title}</Typography>
                        <Chip 
                          label={getTypeLabel(notification.type)} 
                          size="small" 
                          color={getTypeColor(notification.type)}
                        />
                      </Box>
                    }
                    secondary={notification.message}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default NotificationBell;
